function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2729_88443)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5 10.689V12.2565C9.82119 12.0165 9.09471 11.9429 8.38155 12.0418C7.6684 12.1408 6.9894 12.4094 6.40157 12.8252C5.81375 13.2409 5.33426 13.7916 5.00337 14.4311C4.67249 15.0705 4.49986 15.78 4.5 16.5L3 16.4993C2.99977 15.5834 3.20919 14.6797 3.61222 13.8573C4.01526 13.0349 4.6012 12.3157 5.32516 11.7548C6.04912 11.1939 6.89188 10.8061 7.78887 10.6212C8.68585 10.4364 9.61325 10.4593 10.5 10.6883V10.689ZM9 9.75C6.51375 9.75 4.5 7.73625 4.5 5.25C4.5 2.76375 6.51375 0.75 9 0.75C11.4862 0.75 13.5 2.76375 13.5 5.25C13.5 7.73625 11.4862 9.75 9 9.75ZM9 8.25C10.6575 8.25 12 6.9075 12 5.25C12 3.5925 10.6575 2.25 9 2.25C7.3425 2.25 6 3.5925 6 5.25C6 6.9075 7.3425 8.25 9 8.25ZM13.9395 12.75L12.5677 11.379L13.629 10.3177L16.8105 13.5L13.629 16.6823L12.5677 15.621L13.9395 14.25H11.25V12.75H13.9395Z",
  fill: "#07003D",
  fillOpacity: 0.3
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2729_88443"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})));

var SvgApplicantIcon = function SvgApplicantIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApplicantIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/applicantIcon.97ae10f9.svg";
export { ForwardRef as ReactComponent };